module.exports = __webpack_public_path__ + "img/honey.74629e7c.svg";